import React, { useContext } from 'react';
import { JobSearchContext } from '../../context';
import { ORGANIZATIONS_SEARCH_PATH, ORGANIZATIONS_PATH } from '../../../utilities/devex_paths';
import styles from './top_employers.module.scss';

const CLOUDINARY_URL = 'https://res.cloudinary.com/devex/image/fetch/c_fit,f_auto,q_auto,h_60,w_60/';

const TopEmployers = () => {
  const { landingPageInfo } = useContext(JobSearchContext);
  const { topEmployers, topEmployersTitle } = landingPageInfo;

  const renderOrgList: JSX.Element = (
    <div className={`${styles.orgsContainer} pt-1 pb-3 row`}>
      {topEmployers.map((org) => (
        <div key={org.id} className='col-12 pt-3'>
          <a
            href={`${ORGANIZATIONS_PATH}/${org.slug_and_id}`}
            className='link-gray-orange'
            target='_blank'
            data-testid='org-link'
            rel='noreferrer'
          >
            <div className='d-flex w-100'>
              <div className='text-center'>
                <div className={`${styles.logo} p-1 d-block position-relative text-center`}>
                  {org.logo_url ? (
                    <img alt='Organization logo' src={`${CLOUDINARY_URL}${org.logo_url}`} />
                  ) : (
                    <i className='icon-building fal' />
                  )}
                </div>
              </div>
              <div
                className={`${styles.infoContainer} align-middle`}
                data-testid='job-info-container'
              >
                <div className='ps-2'>
                  <div className='strong' data-testid='org-name'>
                    {org.name}
                  </div>
                  <small className='strong'>
                    {org.active_jobs_count} open position{org.active_jobs_count > 1 ? 's' : ''}
                  </small>
                </div>
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );

  return (
    <section className='mt-45 mb-48 mx-0 position-relative' data-testid='top-employers-section'>
      <div className='clearfix'>
        <h2>{topEmployersTitle}</h2>
      </div>
      {renderOrgList}
      <div className='mt-3 d-flex justify-content-end'>
        <a
          className='link-blue-orange'
          href={`${ORGANIZATIONS_SEARCH_PATH}?filter[top_employers_only]=true`}
          data-testid='see-all-organizations-hiring-link'
        >
          Find other top employers
          <i className='fal icon-arrow-right ms-2' />
        </a>
      </div>
    </section>
  );
};

export default TopEmployers;
